<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    

      
      
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
    
    
     <!--start new row-->
         <div class="row">

        <div class="col-xl-6">
          <card>
            <template slot="header">
              <!-- Subtitle -->
              <h6 class="surtitle">Ordinary Shares</h6>
              <!-- Title -->
              <h5 class="h3 mb-0">Shareholding</h5>
            </template>
            <div class="chart">
              <pie-chart
                id="pie-chart"
                :height="350"
                :chart-data="pieChart.chartData"
                :extra-options="pieChart.extraOptions"
              >
              </pie-chart>
            </div>
          </card>
        </div>
        <!-- start new column-->
        <div class="col-xl-6">
        	<card gradient="default" no-body="">
              <div class="card-body text-center" >
              	  <div style="">
                     <h2 class="text-success">Total Paid-Up Capital</h2>
                	  <sup class="text-white">$</sup> <span class="h2 text-white">{{total_paid_up_capital_str}}</span>
                  </div>
              </div>

            </card>
            
            
         <card v-if="controllers.length>0">   
          <div slot="header" class="row align-items-center">
              <div class="col text-center">
                <h3 class="h3">Register Of Controllers</h3>
              </div>
            </div>
            
        <el-table v-if="controllers.length>0" class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="controllers">
         		 <el-table-column label="Shareholder" min-width="140px">
						<template slot-scope="scope">
							<span v-if="scope.row.shareholder.is_company!=1"> 
							 {{scope.row.shareholder.person.first_name}}  {{scope.row.shareholder.person.last_name}}
							</span>	 
							<span v-if="scope.row.shareholder.is_company==1"> 
							 {{scope.row.shareholder.shareholder_company.company_name}}  ({{scope.row.shareholder.shareholder_company.company_reg_num}})
							</span>
						</template>
					</el-table-column>

					<el-table-column label="Ownership" min-width="140px">
						<template slot-scope="scope">
							 <span >{{scope.row.percentage}} %</span>
						</template>
					</el-table-column>
					<el-table-column label="Num Shares" property="num_shares" min-width="140px">
						<template slot-scope="scope">
							 <span >{{scope.row.num_shares}} Ordinary</span>
						</template>
					</el-table-column>

        </el-table>
		</card>        
        
        </div>
        
        
        
        </div>
	 <!--end new row-->

    	
    	
    	
    	
      <div class="row">
      
      
       <div v-for="s in shareholders"  :key="s.key_id" class="col-xl-4">
          <card header-classes="bg-gradient-default">
            <div slot="header" class="row align-items-center">
              <div class="col text-center">
                <h3 class="h3 text-white">
                  {{s.pivot.num_shares}} 
                	<span v-if="s.pivot.share_type==1">Ordinary</span>
                	<span v-if="s.pivot.share_type==2">Preference</span>
                	
                	Shares
                
                </h3>
              </div>
            </div>

            <div>
               <span class="h6 surtitle">Name</span>
                <div class="h3 ">
                <span v-if="s.is_company==1">
              	  {{s.shareholder_company.company_name}}
                </span>
                <span v-else> 
                	 {{s.person.first_name}} {{s.person.last_name}}
                </span>
                
                </div>
             </div>
             
             
              <div style="margin-top:30px;">
                <span class="h6 surtitle">Paid-up Capital</span>
                <div class="h3 ">
                	<span >{{s.pivot.paid_up_capital}} {{s.pivot.currency}}</span>
               		
                
                </div>
             </div>
             
             <div style="margin-top:30px;">
                <span class="h6 surtitle">Address</span>
                <div class="h3 ">
                	 <span v-if="s.is_company==1">
              			  {{s.shareholder_company.address}}
                	</span>
                	<span v-else> {{s.person.address_1}}</span>
                
                </div>
             </div>
             
              <div v-if="s.is_company==1 && s.shareholder_company.person" style="margin-top:30px;">
                <span class="h6 surtitle">Contact Person</span>
                <div class="h3 ">
                	{{s.shareholder_company.person.first_name}}  	{{s.shareholder_company.person.last_name}} 
                
                </div>
             </div>
             
             
             
            
             <div style="margin-top:30px;">
                <span class="h6 surtitle">Email</span>
                <div class="h3 ">
                	 <span v-if="s.is_company==1">
              			  {{s.shareholder_company.person.email}}
                	</span>
                	<span v-else> {{s.person.email}}</span>
                
                </div>
             </div>
             
         
               <div style="margin-top:30px;">
                <span class="h6 surtitle">Contact Number</span>
                <div class="h3 ">
                	 <span v-if="s.is_company==1">
              			  {{s.shareholder_company.person.contact_num}}
                	</span>
                	<span v-else> {{s.person.contact_num}}</span>
                </div>
             </div>
        
              
             
             
        	 <div v-if="s.cert" style="text-align:center;margin-top:35px;">
        	 <base-button @click="viewDocument(s.cert)" type="success">Share Certificate</base-button>
        	 </div>
          
          
          </card>
        </div>
       <!-- end column --> 
    

       
      </div>
      <!-- End row-->

   


    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import PieChart from '@/components/Charts/PieChart';
  import { Charts } from "@/components/Charts/config";
  import { Pie, mixins } from 'vue-chartjs';
  import { Table, TableColumn} from 'element-ui'
  
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  

  export default {
    components: {
  		PieChart,
  		[Table.name]: Table,
       [TableColumn.name]: TableColumn,
    },
    data() {
      return {
     	 shareholders:[],
     	 shChartData:[],
     	 controllers:[],
     	 total_paid_up_capital_str:'',
     	  pieChart: {
            chartData: {
            labels: [
              'Danger',
              'Warning',
              'Success',
              'Primary',
              'Info'
            ],
            datasets: [{
              data: this.shChartData,
              backgroundColor: [
                Charts.colors.theme['danger'],
                Charts.colors.theme['warning'],
                Charts.colors.theme['success'],
                Charts.colors.theme['primary'],
                Charts.colors.theme['info'],
  
              ],
              label: 'Dataset 1'
            }],
          },
          extraOptions: {
            responsive: true,
            legend: {
              position: 'top',
            },
            animation: {
              animateScale: true,
              animateRotate: true
            }
          }
        },//end piechard
	
      };
    },
    methods: {
      initBigChart(index) {

      },
       viewDocument(did){
      			this.$router.push( '/view-document/'+ did +"/0");
        },
    },
    mounted() {

      	 swal.showLoading();
		const client_info = JSON.parse(TokenService.getUserInfo());
      	let uri = this.$base_url+'/api/v1/c/get_e_shareholders/'+ client_info.entity_id;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.shareholders = response.data.shareholders;
      		 this.total_paid_up_capital_str = response.data.total_paid_up_capital_str;
      		 if(response.data.controllers){
      		 	this.controllers = response.data.controllers;
      		 }
      		
   			
   			let chartData = {
				  datasets: [
					{
					  label: 'Performance',
					  data:  response.data.chart.data,
					  backgroundColor: [
							Charts.colors.theme['danger'],
							Charts.colors.theme['warning'],
							Charts.colors.theme['success'],
							Charts.colors.theme['primary'],
							Charts.colors.theme['info'],
  
            		  ]
					}
				  ],
				  labels: response.data.chart.label,
				};	
				
			 this.pieChart.chartData = chartData;
			 swal.close();
			 
			 	
      	})//end api call
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














